import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toastError",
  "use": "toastError-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"toastError\"><circle cx=\"16\" cy=\"16\" fill=\"#fff\" fill-opacity=\".2\" r=\"16\" /><g stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"1.5\"><path d=\"m12 12.3999 7.7139 7.7139\" /><path d=\"m12 20.1138 7.7139-7.7139\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol